import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
import { Sparkles } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-rose-50 via-pink-50 to-amber-50" data-id="element-91">
      {/* Decorative elements */}
      <div className="absolute inset-0 opacity-10" data-id="element-92">
        <div className="absolute top-20 left-10 w-64 h-64 bg-rose-300 rounded-full blur-3xl" data-id="element-93"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-pink-300 rounded-full blur-3xl" data-id="element-94"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 py-20 text-center" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-96">
          <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm px-6 py-3 rounded-full shadow-lg mb-8" data-id="element-97">
            <Sparkles className="w-5 h-5 text-rose-500" data-id="element-98" />
            <span className="text-sm font-medium text-rose-600" data-id="element-99">
              Baseado em depoimentos reais de noivas brasileiras
            </span>
          </div>

          <h1 className="font-serif text-5xl md:text-7xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-100">
            A Fórmula do{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-rose-500 to-pink-600" data-id="element-101">
              Efeito Boutique™
            </span>
          </h1>

          <p className="text-2xl md:text-3xl text-gray-700 font-light leading-relaxed max-w-4xl mx-auto mb-12" data-id="element-102">
            40 ideias completas, testadas e aprovadas para você fazer
            lembrancinhas que parecem caras{' '}
            <span className="font-semibold text-rose-600" data-id="element-103">
              gastando 5 a 10 vezes menos
            </span>
          </p>

          <p className="text-xl text-gray-600 mb-12 max-w-2xl mx-auto" data-id="element-104">
            <span className="font-semibold" data-id="element-105">
              Mesmo sem saber fazer artesanato.
            </span>{' '}
            Mesmo com orçamento apertado. Mesmo com medo de "fazer feio".
          </p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4,
          duration: 0.6
        }} data-id="element-106">
            <CTAButton size="large" onClick={scrollToPricing} data-id="element-107">
              Quero Transformar Minhas Lembrancinhas Agora
            </CTAButton>
          </motion.div>

          <p className="text-sm text-gray-500 mt-6" data-id="element-108">
            40 ideias prontas • Passo a passo simples • Economia de até 70%
          </p>
        </motion.div>
      </div>

      {/* Decorative bottom wave */}
      <div className="absolute bottom-0 left-0 right-0" data-id="element-109">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-110">
          <path d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="white" data-id="element-111" />
        </svg>
      </div>
    </section>;
}